const selectors = {
  productContainer: document.querySelector('.product-details-wrapper'),
  productMedia: document.querySelector('[data-productMedia]')
};

const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
window.productMedia = mediaJSON;
class TemplateProductJS {
  constructor() {
     this.checkEventPopup();
    if(document.querySelectorAll('.product-thumb--image').length > 0) {
      document.querySelectorAll('.product-thumb--image').forEach(function(target) {
        target.addEventListener('click', (event) => {
          event.preventDefault();
          setTimeout(function() {
            document.querySelectorAll('.product-thumb--image').forEach(function(targetT) {
              targetT.classList.remove('swiper-slide-thumb-active');
            });
            target.classList.add('swiper-slide-thumb-active');
          }, 200);
          if (typeof productSlider !== 'undefined' && productSlider) {
            productSlider.slideTo(event.target.closest('.product-thumb--image').getAttribute('data-index'));
          }
        });
      });
    }
  }

    checkEventPopup(){
 
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        console.log("test")
        if(entry.isIntersecting){
          document.body.classList.add('overflow-hidden');
        } else {
         document.body.classList.remove('overflow-hidden');
        }
      })
    });
       setInterval(()=> {
         if(document.querySelectorAll('.evey-modal').length > 0){
          document.querySelectorAll('.evey-modal').forEach(ele=>{
             
             observer.observe(ele);
           });
         }
       },100)
          
        
    
  }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
